import { FC } from 'react';
import { TradingFormField } from '../../trading-form-field';
import { MaType } from '@shared/types';
import { IndicatorIndexedPath } from '../indicator-config-form.utils';

type MaFieldsProps = {
  path: IndicatorIndexedPath;
};

export const MaFields: FC<MaFieldsProps> = ({ path }) => (
  <>
    <TradingFormField type="numeric" name={`${path}.period`} label="Period" />
    <TradingFormField
      type="select"
      name={`${path}.maType`}
      label="MA Type"
      options={Object.values(MaType)}
      defaultValue={MaType.SMA}
    />
  </>
);
